import React, {
  useState,
  useEffect
} from 'react';

interface GlobalState {
  data: any;
  listeners: { [name: string] : ((data: any) => void); };
  listenerLastId: number;
}

const globalStates: { [name: string] : GlobalState; } = {}

function updateGlobalState(name: string, data: any) {
  let state = globalStates[name];
  if (!state) {
    return;
  }
  state.data = data;
  Object.entries(state.listeners).forEach(([key, listener]) => {
    listener(data)
  });
}

export function useGlobalState(name: string, initialData: any) {
  const [data, setData] = useState(initialData);
  const [registered, setRegistered] = useState(false);
  const [listenerId, setListenerId] = useState(0);

  if (!globalStates[name]) {
    globalStates[name] = {
      data: initialData,
      listeners: {},
      listenerLastId: 0
    };
  }

  if (!registered) {
    const listenerId = globalStates[name].listenerLastId + 1;
    globalStates[name].listeners[listenerId] = (data: any) => {
      setData(data);
    }
    globalStates[name].listenerLastId = listenerId;
    setRegistered(true);
    setListenerId(listenerId);
  }

  useEffect(() => {
    return () => {
      delete globalStates[name].listeners[listenerId];
    }
  }, [])

  const updateData = (data: any) => {
    updateGlobalState(name, data);
  }

  return [
    data,
    updateData,
  ];
}